module.exports = __webpack_public_path__ + "media/images/sectors-cta-4f53ccf02dd749a47ef4a4911ae06061.jpg";